import { api } from "./client";
import type { Enterprise, Paginated } from "./types";

export const enterprisesApi = {
  list: (params: Record<string, unknown> = {}) =>
    api.get<Paginated<Enterprise>>("/enterprises/", { params }).then((r) => r.data),
  create: (payload: Partial<Enterprise>) =>
    api.post<Enterprise>("/enterprises/", payload).then((r) => r.data),
  update: (id: string, payload: Partial<Enterprise>) =>
    api.patch<Enterprise>(`/enterprises/${id}/`, payload).then((r) => r.data),
  remove: (id: string) => api.delete(`/enterprises/${id}/`),
};
